import React, { useState } from 'react';
import { X, Upload, AlertCircle } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Textarea } from './ui/textarea';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';

const CreateTicketModal = ({ isOpen, onClose, asset, onCreateTicket, hasOpenTicket }) => {
  const [description, setDescription] = useState('');
  const [photo, setPhoto] = useState(null);

  const handleSubmit = () => {
    if (!description.trim()) return;
    
    onCreateTicket({
      assetId: asset.id,
      description,
      photo
    });
    
    setDescription('');
    setPhoto(null);
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="create-ticket-modal">
        <DialogHeader>
          <DialogTitle>Create Maintenance Ticket</DialogTitle>
          <DialogDescription>
            Report an issue for {asset?.name}
          </DialogDescription>
        </DialogHeader>

        {hasOpenTicket ? (
          <div className="ticket-warning">
            <AlertCircle size={24} className="warning-icon" />
            <div>
              <h4 className="warning-title">Ticket Already Open</h4>
              <p className="warning-text">
                A maintenance ticket is already open for this asset. Please wait for it to be resolved before creating a new one.
              </p>
            </div>
          </div>
        ) : (
          <div className="ticket-form">
            <div className="form-group">
              <Label htmlFor="description">Problem Description *</Label>
              <Textarea
                id="description"
                placeholder="Describe the problem in detail..."
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                rows={4}
                className="ticket-textarea"
              />
            </div>

            <div className="form-group">
              <Label htmlFor="photo">Photo (Optional)</Label>
              <div className="file-upload">
                <Input
                  id="photo"
                  type="file"
                  accept="image/*"
                  onChange={(e) => setPhoto(e.target.files[0])}
                  className="file-input"
                />
                <div className="file-upload-text">
                  <Upload size={20} />
                  <span>{photo ? photo.name : 'Upload a photo of the issue'}</span>
                </div>
              </div>
            </div>
          </div>
        )}

        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          {!hasOpenTicket && (
            <Button 
              onClick={handleSubmit}
              disabled={!description.trim()}
            >
              Create Ticket
            </Button>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default CreateTicketModal;
